import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";
import { FILE_NAME } from "../constants/exportFileNames";

export const getCoursesBySkillPathId = (id) => {
  return base.get({
    url: API_PARAM.SKILL_PATH_COURSES,
    params: { id },
  });
};

export const getSkillpathCertificate = async (id, skillpath) => {
  return base.exportFile({
    method: "post",
    url: API_PARAM.SKILL_PATH_CERTIFICATE,
    params: { id },
    fileName:  FILE_NAME.SKILLPATHS_CERTIFICATE.replace(
      "{skillpath}",
      skillpath
    ),
  });
};

export const getSkillpathShareUrl = async (id) => {
  return base.post({
    url: API_PARAM.SKILL_PATH_SHARE_URL,
    params: { id },
    nonceHeader: true,
  });
};

export const getUpdates = (dateTime) => {
  return base.get({
    url: API_PARAM.COURSE_STATUS,
    params: { timeStamp: dateTime },
  });
};

export const getInProgressCourses = () => {
  return base.get({
    url: API_PARAM.COURSES_IN_PROGRESS,
  });
};

export const getCourseById = (id) => {
  return base.get({
    url: API_PARAM.COURSE,
    params: { id },
  });
};

export const getDoceboToken = () => {
  return base.get({
    url: API_PARAM.PLAYER_TOKEN,
  });
};

export const getUsersJobCourses = () => {
  return base.get({
    url: API_PARAM.USERS_JOB_COURSES,
  });
};

export const saveCourseTrack = (data) => {
  return base.post({
    url: API_PARAM.COURSE_TRACK,
    data: data,
    nonceHeader: true,
  });
};